import {
  Gap,
  RowGap,
  ColumnGap,
  Padding,
  PaddingValue,
  CssVariable,
} from '@wix/css-property-parser';

export type GapParsedValue = {
  rowGap: string | null;
  columnGap: string | null;
};

export type PaddingParsedValue = {
  paddingTop: string | null;
  paddingRight: string | null;
  paddingBottom: string | null;
  paddingLeft: string | null;
};

export const parseGapValue = (value: string): GapParsedValue => {
  const gap = Gap.parse(value);

  const values: GapParsedValue = {
    rowGap: null,
    columnGap: null,
  };

  if (!gap) {
    return values;
  }

  if ('type' in gap && gap.type === 'variable') {
    Object.keys(values).forEach((key) => {
      values[key as keyof GapParsedValue] = CssVariable.toCSSValue(gap);
    });

    return values;
  }

  if ('rowGap' in gap && gap.rowGap) {
    values.rowGap = RowGap.toCSSValue(gap.rowGap);
  }
  if ('columnGap' in gap && gap.columnGap) {
    values.columnGap = ColumnGap.toCSSValue(gap.columnGap);
  }

  return values;
};

export const parsePaddingValue = (value: string): PaddingParsedValue => {
  const padding = Padding.parse(value);

  const values: PaddingParsedValue = {
    paddingTop: null,
    paddingRight: null,
    paddingBottom: null,
    paddingLeft: null,
  };

  if (!padding) {
    return values;
  }

  if ('type' in padding && padding.type === 'variable') {
    Object.keys(values).forEach((key) => {
      values[key as keyof PaddingParsedValue] = CssVariable.toCSSValue(padding);
    });

    return values;
  }

  if ('paddingTop' in padding && padding.paddingTop) {
    values.paddingTop = Padding.toCSSValue(padding.paddingTop as PaddingValue);
  }
  if ('paddingRight' in padding && padding.paddingRight) {
    values.paddingRight = Padding.toCSSValue(
      padding.paddingRight as PaddingValue,
    );
  }
  if ('paddingBottom' in padding && padding.paddingBottom) {
    values.paddingBottom = Padding.toCSSValue(
      padding.paddingBottom as PaddingValue,
    );
  }
  if ('paddingLeft' in padding && padding.paddingLeft) {
    values.paddingLeft = Padding.toCSSValue(
      padding.paddingLeft as PaddingValue,
    );
  }

  return values;
};
